import { getEmbeddingModelDataSelector } from 'features/embeddingModels/store/selectors';
import { BaseSetting } from 'features/modular-workflow/runner/settings/BaseSetting';
import { InputRendererContext } from 'features/modular-workflow/runner/settings/InputRenderer';
import { TargetAudienceAutocomplete } from 'features/target-audience/TargetAudienceAutocomplete';
import { useContext } from 'react';
import { useAppSelector } from 'store/hooks';

export const DataTypeTargetAudience = () => {
  const { input, onChange, step, inputValues: values } = useContext(InputRendererContext);
  const getModelById = useAppSelector(getEmbeddingModelDataSelector);

  const handleTargetAudienceChange = (targetAudienceId?: string) => {
    onChange(input, targetAudienceId ?? null);
  };

  const { value, reference } =
    step.inputs.find(({ data_type }) => data_type.type === 'language') ?? {};
  const langModelId = (reference && values[reference]) ?? value ?? '';
  const langModel = getModelById(langModelId as string);

  return (
    <BaseSetting>
      {elementId => (
        <TargetAudienceAutocomplete
          id={elementId}
          targetLanguage={langModel?.language}
          targetCountry={langModel?.country}
          initialTargetAudienceId={values.targetAudienceId as string | undefined}
          onTargetAudienceIdChange={handleTargetAudienceChange}
          fullWidth={true}
        />
      )}
    </BaseSetting>
  );
};
